<template>
  <div class="tableContainer">
    <div class="tableTitle">
      <el-row :gutter="20">
        <el-col :span="6">
          <div class="grid-content bg-purple"><span>Brand</span></div>
        </el-col>
        <el-col :span="4">
          <div class="grid-content bg-purple">
            <span>Total<br />TGT(K)</span>
          </div>
        </el-col>
        <el-col :span="4">
          <div class="grid-content bg-purple">
            <span>YTD<br />Ach.%</span>
          </div>
        </el-col>
        <el-col :span="3">
          <div class="grid-content bg-purple">
            <span>YTD<br />vs.LY</span>
          </div>
        </el-col>
        <el-col :span="4">
          <div class="grid-content bg-purple">
            <span>TD<br />vs.TGT</span>
          </div>
        </el-col>
        <el-col :span="4">
          <div class="grid-content bg-purple">
            <span>TD<br />Contri.%</span>
          </div>
        </el-col>
      </el-row>
    </div>
    <div v-if="AllMyData">
      <el-row :gutter="20" class="tableAll" style="border-bottom:1px solid lightgrey">
        <el-col :span="6">
          <div class="grid-content bg-purple">
            <!-- <span v-if="AllMyData.category=='Professional Skin Care'">Professional<br/>Skin Care</span> -->
            <span v-if="ChangeFlag=='tab3'">DCL</span>
            <span v-else>All Brands</span>
          </div>
        </el-col>
        <el-col :span="4">
          <div class="grid-content bg-purple">
            <span>{{Math.round(AllMyData.TARGET_VALUE_Total / 1000) | NumFormat}}</span>
          </div>
        </el-col>
        <el-col :span="4">
          <div class="grid-content bg-purple">
            <span>{{ AllMyData.YTD_Achiving | Percent }}%</span>
          </div>
        </el-col>
        <el-col :span="3">
          <div class="grid-content bg-purple">
            <span>{{ AllMyData.YTD_VS_LY | Zheng }}</span>
          </div>
        </el-col>
        <el-col :span="4">
          <div class="grid-content bg-purple">
            <span>{{ AllMyData.TD_VS_TGT | Percent }}%</span>
          </div>
        </el-col>
        <el-col :span="4">
          <div class="grid-content bg-purple">
            <span>{{ AllMyData.TD_Contri | Percent }}%</span>
          </div>
        </el-col>
      </el-row>
    </div>
    <div>
      <div v-for="(item, i) in TableList1" :key="formaterKey(item,1)" @click.stop="show(i, $event)">
        <el-row :gutter="20" class="tableItem itemActive">
          <el-col :span="6">
            <div class="grid-content bg-purple">
              <div class="tableItemImg" :class="showFirst?'':'redPlusActiveImg'"></div>
              <span>{{ formaterKey(item,1) }}</span>
            </div>
          </el-col>
          <el-col :span="4">
            <div class="grid-content bg-purple">
              <span>{{ Math.round(item.TARGET_VALUE_Total / 1000) | NumFormat}}</span>
            </div>
          </el-col>
          <el-col :span="4">
            <div class="grid-content bg-purple">
              <span>{{ item.YTD_Achiving | Percent }}%</span>
            </div>
          </el-col>
          <el-col :span="3">
            <div class="grid-content bg-purple">
              <span>{{ item.YTD_VS_LY | Zheng }}</span>
            </div>
          </el-col>
          <el-col :span="4">
            <div class="grid-content bg-purple">
              <span>{{ item.TD_VS_TGT | Percent }}%</span>
            </div>
          </el-col>
          <el-col :span="4">
            <div class="grid-content bg-purple">
              <span>{{ item.TD_Contri | Percent }}%</span>
            </div>
          </el-col>
        </el-row>
        <div v-for="item1 in formaterList(item,1)" :key="formaterKey(item1,2)" class="first" v-show="showFirst" @click.stop="showSec(i, $event)">
          <div class="secoend">
            <el-row :gutter="20" class="tableItem1" :class="formaterKeyValue(item1,2) == 'shop' ? 'last-level':''">
              <el-col :span="6">
                <div class="grid-content bg-purple">
                  <div class="tableItemImg1 redPlusActiveImg" v-if="formaterList(item1,2).length > 0"></div>
                  <span>{{ formaterKey(item1,2) }}</span>
                </div>
              </el-col>
              <el-col :span="4">
                <div class="grid-content bg-purple">
                  <span>{{ Math.round(item1.TARGET_VALUE_Total / 1000) | NumFormat}}</span>
                </div>
              </el-col>
              <el-col :span="4">
                <div class="grid-content bg-purple">
                  <span>{{ item1.YTD_Achiving | Percent }}%</span>
                </div>
              </el-col>
              <el-col :span="3">
                <div class="grid-content bg-purple">
                  <span>{{ item1.YTD_VS_LY | Zheng }}</span>
                </div>
              </el-col>
              <el-col :span="4">
                <div class="grid-content bg-purple">
                  <span>{{ item1.TD_VS_TGT | Percent }}%</span>
                </div>
              </el-col>
              <el-col :span="4">
                <div class="grid-content bg-purple">
                  <span>{{ item1.TD_Contri | Percent }}%</span>
                </div>
              </el-col>
            </el-row>
            <div class="third" v-for="item2 in formaterList(item1,2)" v-show="secoendFlag" :key="formaterKey(item2,3)"
              @click.stop="showThr(i, $event)">
              <el-row :gutter="20" class="tableItem2" :class="formaterKeyValue(item2,3) == 'shop' ? 'last-level':''">
                <el-col :span="6">
                  <div class="grid-content bg-purple">
                    <div class="tableItemImg2 redPlusActiveImg" v-if="formaterList(item2,3).length > 0"> </div>
                    <span>{{ formaterKey(item2,3) }}</span>
                  </div>
                </el-col>
                <el-col :span="4">
                  <div class="grid-content bg-purple">
                    <span>{{ Math.round(item2.TARGET_VALUE_Total / 1000) | NumFormat}}</span>
                  </div>
                </el-col>
                <el-col :span="4">
                  <div class="grid-content bg-purple">
                    <span>{{ item2.YTD_Achiving | Percent }}%</span>
                  </div>
                </el-col>
                <el-col :span="3">
                  <div class="grid-content bg-purple">
                    <span>{{ item2.YTD_VS_LY | Zheng }}</span>
                  </div>
                </el-col>
                <el-col :span="4">
                  <div class="grid-content bg-purple">
                    <span>{{ item2.TD_VS_TGT | Percent }}%</span>
                  </div>
                </el-col>
                <el-col :span="4">
                  <div class="grid-content bg-purple">
                    <span>{{ item2.TD_Contri | Percent }}%</span>
                  </div>
                </el-col>
              </el-row>
              <div class="four" v-for="item3 in formaterList(item2,3)" v-show="secoendFlag" :key="formaterKey(item3,4)">
                <el-row :gutter="20" class="tableItem3" :class="formaterKeyValue(item3,4) == 'shop' ? 'last-level':''">
                  <el-col :span="6">
                    <div class="grid-content bg-purple">
                      <span>{{ formaterKey(item3,4) }}</span>
                    </div>
                  </el-col>
                  <el-col :span="4">
                    <div class="grid-content bg-purple">
                      <span>{{ Math.round(item3.TARGET_VALUE_Total / 1000) | NumFormat}}</span>
                    </div>
                  </el-col>
                  <el-col :span="4">
                    <div class="grid-content bg-purple">
                      <span>{{ item3.YTD_Achiving | Percent }}%</span>
                    </div>
                  </el-col>
                  <el-col :span="3">
                    <div class="grid-content bg-purple">
                      <span>{{ item3.YTD_VS_LY | Zheng }}</span>
                    </div>
                  </el-col>
                  <el-col :span="4">
                    <div class="grid-content bg-purple">
                      <span>{{ item3.TD_VS_TGT | Percent }}%</span>
                    </div>
                  </el-col>
                  <el-col :span="4">
                    <div class="grid-content bg-purple">
                      <span>{{ item3.TD_Contri | Percent }}%</span>
                    </div>
                  </el-col>
                </el-row>

              </div>
            </div>
          </div>
        </div>
      </div>
    </div>


  </div>
</template>
<script>
import $ from "jquery";
export default {
  props: {
    ChangeFlag: {
      type: String,
      default: ''
    },
    TableList1: {
      type: Array,
      default: () => []
    },
    AllMyData: {
      type: Object,
      default: () => null
    }
  },
  data() {
    return {
      tableList1: [],
      tableList2: [],
      AllData: [],
      secoendFlag: false,
      firstFlag: false,
      FirstactiveFlag: false,
    };
  },
  methods: {
    // 用于设置每一层的key
    formaterKey(data,level){
      if(this.ChangeFlag == 'tab1'){
        if(level == 1){
          return data.category
        }else if(level == 2){
          return data.brand
        }else if(level ==3){
          return data.channel
        }else{
          return data.shop
        }
      }else if(this.ChangeFlag == 'tab2'){
        if(level == 1){
          return data.brand
        }else if(level == 2){
          return data.channel
        }else{
          return data.shop
        }
      }else if(this.ChangeFlag == 'tab3'){
        if(level == 1){
          return data.channel
        }else{
          return data.shop
        }
      }else{
        return ''
      }
    },
    // 用于判断是否最后一层shop，控制样式
    formaterKeyValue(data,level){
      if(this.ChangeFlag == 'tab1'){
        if(level == 1){
          return 'category'
        }else if(level == 2){
          return 'brand'
        }else if(level ==3){
          return 'channel'
        }else{
          return 'shop'
        }
      }else if(this.ChangeFlag == 'tab2'){
        if(level == 1){
          return 'brand'
        }else if(level == 2){
          return 'channel'
        }else{
          return 'shop'
        }
      }else if(this.ChangeFlag == 'tab3'){
        if(level == 1){
          return 'channel'
        }else{
          return 'shop'
        }
      }else{
        return ''
      }
    },
    // 用于不同分类的各层级的循环遍历
    formaterList(data,level){
      if(this.ChangeFlag == 'tab1'){
        if(level == 1){
          return data.brandList
        }else if(level == 2){
          return data.channelList
        }else if(level ==3){
          return data.shopList
        }else{
          return []
        }
      }else if(this.ChangeFlag == 'tab2'){
        if(level == 1){
          return data.channelList
        }else if(level == 2){
          return data.shopList
        }else{
          return []
        }
      }else if(this.ChangeFlag == 'tab3'){
        if(level == 1){
          return data.shopList
        }else{
          return []
        }
      }else{
        return []
      }
    },
    showFour(i, e) {
      var flag2 = $(e.currentTarget).find(".tableItemImg2").attr("class");
      if (flag2 == "tableItemImg2") {
        $(e.currentTarget).find(".tableItemImg2").addClass("redPlusActiveImg");
        $(e.currentTarget).find(".tableItem").removeClass("itemActive");
      } else {
        $(e.currentTarget).find(".tableItemImg2").removeClass("redPlusActiveImg");
        $(e.currentTarget).find(".tableItem").addClass("itemActive");
      }
      $(e.currentTarget).stop().find(".first").slideToggle(500);
    },
    show(i, e) {

      var flag = $(e.currentTarget).find(".tableItemImg").attr("class");
      console.log('------------>xxx', flag)
      if (flag == "tableItemImg") {
        $(e.currentTarget).find(".tableItem").removeClass("itemActive");
        $(e.currentTarget).find(".tableItemImg").addClass("redPlusActiveImg");
      } else {
        $(e.currentTarget).find(".tableItemImg").removeClass("redPlusActiveImg");
        $(e.currentTarget).find(".tableItem").addClass("itemActive");
      }
      $(e.currentTarget).stop().find(".first").slideToggle(500);
    },
    showSec(i, e) {
      var flag1 = $(e.currentTarget).find(".tableItemImg1").attr("class");
      if (flag1 == "tableItemImg1") {
        $(e.currentTarget).find(".tableItem1").removeClass("itemActive1");
        $(e.currentTarget).find(".tableItemImg1").addClass("redPlusActiveImg");
      } else {
        $(e.currentTarget).find(".tableItemImg1").removeClass("redPlusActiveImg");
        $(e.currentTarget).find(".tableItem1").addClass("itemActive1");
      }
      $(e.currentTarget).stop().find(".third").slideToggle(500);
    },
    showThr(i, e) {
      var flag3 = $(e.currentTarget).find(".tableItemImg2").attr("class");
      if (flag3 == "tableItemImg2") {
        $(e.currentTarget).find(".tableItem2").removeClass("itemActive2");
        $(e.currentTarget).find(".tableItemImg2").addClass("redPlusActiveImg");
      } else {
        $(e.currentTarget).find(".tableItemImg2").removeClass("redPlusActiveImg");
        $(e.currentTarget).find(".tableItem2").addClass("itemActive2");
      }
      $(e.currentTarget).stop().find(".four").slideToggle(500);
    },
  },
  created() { },
  computed:{
    showFirst:function(){
      if(this.ChangeFlag == 'tab2'){
          return false
        }else{
          return true
        }
    }
  },
  watch: {
    ChangeFlag: {
      handler(newValue, oldValue) {
        console.log('------------>',newValue)

        // this.activeFlag = newValue;
        
      },
      deep: true,
    },
    TableList: {
      handler(newValue, oldValue) {
        this.tableList1 = newValue;
      },
      deep: true,
    },
    AllMyData: {
      handler(newValue, oldValue) {
        this.AllData = newValue;
      },
      deep: true,
    },
  },
};
</script>
<style scoped>
.tableContainer {
  position: relative;
}

span {
  color: #000;
}

.tableTitle span {
  font-weight: bold;
  font-size: 11px;
  line-height: 12px;
  color: #525252;
}

.tableBrand {
  font-weight: normal;
  font-size: 10px;
  line-height: 11px;
}

/deep/ .el-divider--horizontal {
  margin: 0 auto;
}

/deep/ .el-divider {
  background-color: #e4e4e4;
}

.el-row {
  display: flex;
  align-items: center;
  padding: 9px 0 9px 15px;
}

.tableItem {
  position: relative;
  /* box-shadow: 0px 6px 8px rgba(0, 0, 0, 0.3);
  background: #ECEDF4; */
  border-bottom: 1px solid #DDDDDD;
  padding: 20px 0 20px 10px;
}

.tableItemImg {
  position: absolute;
  top: 60%;
  bottom: 0;
  left: 3px;
  width: 0;
  height: 0;
  border: 6px solid transparent;
  border-top: 6px solid #53BCAD;
  transform: translate(0,-60%);
  /* background: url("../../assets/jpg/3杠-关闭.svg") no-repeat center; */
}

.tableItemImg1 {
  position: absolute;
  top: 60%;
  bottom: 0;
  left: 3px;
  width: 0;
  height: 0;
  border: 6px solid transparent;
  border-top: 6px solid #B9E2D1;
  transform: translate(0,-60%);
  /* background: url("../../assets/jpg/2杠-关闭.svg") no-repeat center; */
}

.tableItemImg2 {
  position: absolute;
  top: 60%;
  bottom: 0;
  left: 3px;
  width: 0;
  height: 0;
  border: 6px solid transparent;
  border-top: 6px solid #CBCBCB;
  transform: translate(0,-60%);
  /* background: url("../../assets/jpg/1杠-关闭.svg") no-repeat center; */
}

.tableAll {
  padding: 20px 0 20px 15px;
  /* background: rgba(207, 64, 68, 0.5); */
  box-shadow: 0px 0px 5px 0 rgba(0, 0, 0, 0.15);
}

.tableAll span {
  font-weight: bold;
  font-size: 10px;
  line-height: 12px;
}

.tableItem1 {
  position: relative;
  padding: 20px 0 20px 10px;
  /* background: rgba(207, 64, 68, 0.08); */
  border-bottom: 1px solid #DDDDDD;

}

.tableItem2 {
  position: relative;
  padding: 20px 0 20px 10px;
  /* background: rgba(255, 70, 75, 0.04); */
  border-bottom: 1px solid #DDDDDD;

}

.tableItem1 span,
.tableItem2 span,
.tableItem span,
.tableItem3 span {
  font-size: 10px;
  line-height: 12px;
}

.littleBUtton {
  position: relative;
}

.tableItem3 {
  /* background: rgba(237, 237, 237, .55); */
  border-bottom: 1px solid lightgray;
}
.last-level{
  background: #ECECEC;
  padding: 10px 0 10px 10px !important;
}
.redPlusActiveImg {
  transform: rotate(-90deg);
  top: 45%;
}
</style>


// WEBPACK FOOTER //
// src/components/WarRoom/tableBrand.vue